import React, { FC, MouseEvent, useCallback, useMemo } from 'react';

import cn from 'utils/cn';
import ControlBarButton from '@3.0/Buttons/ControlBarButtons/ControlBarButton';
import { IDataSourceItem } from 'Modules/Studio/DataSources/redux/initialState';
import IngestionButtonIcon from './IngestionButtonIcon';
import { useIngestionByDataSourceContext } from '../../../context/DataSourceIngestion.context';

type TProps = Pick<IDataSourceItem, 'id'> & {
  isRunningIngestion: boolean;
  isDisabled: boolean;
  toolTipText: string;
  startIngestion: () => void;
  stopIngestion: () => void;
};

const IngestionButton: FC<TProps> = ({
  id,
  isRunningIngestion,
  isDisabled,
  toolTipText,
  startIngestion,
  stopIngestion,
}) => {
  const { isLoadingFullIngestionStatus, isFullIngestionActive, isStopping } =
    useIngestionByDataSourceContext();

  const isDisabledDueToFullIngestion = useMemo(
    () => isLoadingFullIngestionStatus || isFullIngestionActive || isStopping,
    [isLoadingFullIngestionStatus, isFullIngestionActive, isStopping]
  );

  const handleClick = useCallback(
    (evt: MouseEvent<HTMLButtonElement>) => {
      evt.stopPropagation();
      if (isRunningIngestion) {
        stopIngestion();
      } else {
        startIngestion();
      }
    },
    [isRunningIngestion, startIngestion, stopIngestion]
  );

  return (
    <ControlBarButton
      data-testid={`${id}-ingestion-by-ds-button`}
      className={cn('', isRunningIngestion ? 'tw:bg-status-alert/10' : 'tw:bg-primary-500/25')}
      disabled={isDisabledDueToFullIngestion || isDisabled}
      onClick={handleClick}
    >
      <IngestionButtonIcon toolTipText={toolTipText} isRunningIngestion={isRunningIngestion} />
    </ControlBarButton>
  );
};

export default IngestionButton;
